var _g;
var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIconService1 = function SvgIconService1(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    stroke: "#5AC8FA",
    strokeWidth: 2,
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#5AC8FA",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.767 38.783a6.335 6.335 0 0 0-8.959 0l-5.755 5.76a6.334 6.334 0 0 0 4.48 10.809 6.294 6.294 0 0 0 4.474-1.846l4.75-4.75a.452.452 0 0 0-.32-.775h-.181a7.615 7.615 0 0 1-2.896-.56.452.452 0 0 0-.493.099l-3.416 3.42a2.716 2.716 0 1 1-3.842-3.84l5.778-5.774a2.715 2.715 0 0 1 3.837 0 1.855 1.855 0 0 0 2.543 0 1.81 1.81 0 0 0 .525-1.15 1.81 1.81 0 0 0-.525-1.393z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.494 30.055a6.335 6.335 0 0 0-8.958 0l-4.746 4.742a.452.452 0 0 0 .33.774h.167a7.601 7.601 0 0 1 2.892.565c.169.07.364.03.493-.1l3.407-3.402a2.716 2.716 0 1 1 3.841 3.842l-4.244 4.24-.036.04-1.484 1.475a2.715 2.715 0 0 1-3.837 0 1.855 1.855 0 0 0-2.543 0 1.81 1.81 0 0 0-.525 1.158 1.81 1.81 0 0 0 .525 1.394 6.28 6.28 0 0 0 1.81 1.266c.095.046.19.082.285.123.095.04.195.072.29.108.095.036.194.068.29.095l.266.073c.181.045.362.081.548.113.223.033.448.054.674.063H43.283l.271-.032c.1-.004.204-.027.321-.027h.154l.312-.045.145-.027.262-.054h.05a6.334 6.334 0 0 0 2.937-1.665l5.76-5.76a6.334 6.334 0 0 0 0-8.959z"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconService1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-service-1.a0b2be8f.svg";
export { ForwardRef as ReactComponent };